module.exports = __webpack_public_path__ + "static/vision-and-visionaries-c03705c4d860d33bb7435b72f764bb9b.jpg";